import { apiRequest } from '@/lib/api/client'

import { toDataset } from './adapter'
import { analyticsResponseSchema, type PerformanceDataset, type PerformanceQuery } from './schema'

/**
 * Reports & Analytics API layer — `GET /v1/algo-pos-be/liotitip/analytics`
 * (WEBLP-3265). Validates the raw contract with `analyticsResponseSchema`, then
 * adapts it into the chart's `PerformanceDataset` via `toDataset`.
 *
 * One response carries all four metrics, so switching the metric card needs no
 * refetch. Date-only `start_at` / `end_at` are read as Asia/Jakarta days with
 * the end date inclusive.
 *
 * To check the page without the backend, see the usage notes in `mock-data.ts`.
 */
const ANALYTICS_PATH = '/v1/algo-pos-be/liotitip/analytics'

export async function fetchPerformance(
  query: PerformanceQuery,
  signal?: AbortSignal,
): Promise<PerformanceDataset> {
  const response = await apiRequest(ANALYTICS_PATH, {
    schema: analyticsResponseSchema,
    searchParams: {
      start_at: query.startDate,
      end_at: query.endDate,
      aggregation: query.aggregation,
    },
    signal,
  })

  return toDataset(response)
}
